import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectAccountId, selectFilteredEngagements } from '@selectors'
import { useParams } from 'react-router-dom'


import { SET_ENGAGEMENTS } from '@actions/types'

import useStyles from './engage.style'

import EngagementList from '@components/engagement-list/engagement-list.component'
import ResponsiveContainer from '@components/responsive-container/responsive-container.component'

const Engage = (props) => {
  const classes = useStyles(props)
  const accountId = useSelector(selectAccountId)

  const { personalAccessCode } = useParams()

  const dispatch = useDispatch()

  const engageRef = `engage/${accountId}/cta`

  const engagements = useSelector(({ firestore: { data } }) => data[engageRef])

  useEffect(() => {
    dispatch({ type: SET_ENGAGEMENTS })
  }, [dispatch, engagements])

  const filteredEngagements = useSelector(selectFilteredEngagements)

  return (
    <div className={classes.container}>
      <ResponsiveContainer className={classes.responsive}>
        <EngagementList
          engagements={filteredEngagements}
          personalAccessCode={personalAccessCode}
        />
      </ResponsiveContainer>
    </div>
  )
}

export default Engage
